import { apiClientV1 } from './apiClient';

export default {
  getLiveSessionNote: (lsId, params) => apiClientV1.get(`/live/video-sessions/${lsId}/note`, { params }),
  getLiveSessionMessages: (lsId) => apiClientV1.get(`/live/video-sessions/${lsId}/messages`),
  getLiveSession: (liveSessionId, guestId) => apiClientV1.get(`/live/video-sessions/${liveSessionId}`, { params: { guestId } }),
  getAttachments: (liveSessionId) => apiClientV1.get(`/live/video-sessions/${liveSessionId}/attachments`),
  getLiveSessionPins: (liveSessionId) => apiClientV1.get(`/live/video-sessions/${liveSessionId}/pins`)
};
